import React, { useEffect, useState, useRef } from 'react';
import EletrictiyPaymentReport from './eletricityPayment';
import WaterPaymentReport from './waterPayment';
import GasPaymentReport from './gasPayment';
import InsurancePaymentReport from './insurancePayment';
import { uitilityOfflineStatusInArray } from '../../../Utils/Common';
import 'antd/dist/antd.css';
import { uitilityReports } from '../../../config/reportName';
import moment from 'moment';
import { DatePicker, Input, Button, Select, Card, Row, Col } from 'antd';

const { Option } = Select;
const { RangePicker } = DatePicker;

// Normalize mode strings so we don't depend on exact casing / spacing
const normalizeMode = (s) => (s || '').toString().trim().toLowerCase();

function UitilityReport2(props) {
    const dateFormat = 'DD-MM-YYYY';
    const modeSelected = useRef(null);

    // Get today's date
    const today = moment();
    const todayFormatted = today.format(dateFormat);

    const [getReportMode, setReportMode] = useState([]);
    const [getMode, setMode] = useState('Eletricity Report'); // default to Electricity
    const [startDate, setStartDate] = useState(todayFormatted);
    const [endDate, setEndDate] = useState(todayFormatted);
    const [dateRange, changeDateRange] = useState([today, today]);
    const [searchStatus, setSearchStatus] = useState(null);
    const [search, setSearch] = useState(null);

    const handleClear = () => {
        setSearch(null);
        setStartDate(todayFormatted);
        setEndDate(todayFormatted);
        changeDateRange([today, today]);
        setSearchStatus(null);
        setMode('Eletricity Report'); // reset to default
    };

    const onChangeDatePickerValue = (dates, dateStrings) => {
        setStartDate(dateStrings[0] || null);
        setEndDate(dateStrings[1] || null);
        if (dateStrings[0] && dateStrings[1]) {
            changeDateRange([
                moment(dateStrings[0], 'DD-MM-YYYY'),
                moment(dateStrings[1], 'DD-MM-YYYY'),
            ]);
        } else {
            changeDateRange(null);
        }
    };

    const onChangeType = (value) => {
        setMode(value);
        setSearchStatus(null); // Reset status when report type changes
    };

    const onChangeTypeStatus = (value) => {
        setSearchStatus(value === '6' ? null : value);
    };

    const onSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSearch = () => {
        // Trigger re-render of child report components
    };

    useEffect(() => {
        setReportMode(uitilityReports);
    }, []);

    // Decide which child to render, tolerant of string differences
    const renderActiveReport = () => {
        const key = normalizeMode(getMode);

        if (key === 'eletricity report' || key === 'electricity report') {
            return (
                <EletrictiyPaymentReport
                    mode={getMode}
                    startDate={startDate}
                    endDate={endDate}
                    search={search}
                    searchStatus={searchStatus}
                    handleSearch={handleSearch}
                />
            );
        }

        if (key === 'water report') {
            return (
                <WaterPaymentReport
                    mode={getMode}
                    startDate={startDate}
                    endDate={endDate}
                    search={search}
                    searchStatus={searchStatus}
                    handleSearch={handleSearch}
                />
            );
        }

        if (key === 'gas report') {
            return (
                <GasPaymentReport
                    mode={getMode}
                    startDate={startDate}
                    endDate={endDate}
                    search={search}
                    searchStatus={searchStatus}
                    handleSearch={handleSearch}
                />
            );
        }

        // Accepts "Insurance Report", "Insurance", "insurance report", etc.
        if (key === 'insurance report' || key === 'insurance') {
            return (
                <InsurancePaymentReport
                    mode={getMode}
                    startDate={startDate}
                    endDate={endDate}
                    search={search}
                    searchStatus={searchStatus}
                    handleSearch={handleSearch}
                />
            );
        }

        return null;
    };

    return (
        <div>
            <div className="content-wrapper bg-white pt-4">
                <div className="content-header my-0 py-0">
                    <Card className="mb-3 shadow-sm">
                        <div className="container-fluid">
                            <Row gutter={[16, 16]} align="middle">
                                {/* Report Type */}
                                <Col xs={24} sm={12} md={5} lg={5}>
                                    <label className="form-label d-block mb-1">Report Type</label>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select Report Type"
                                        onChange={onChangeType}
                                        value={getMode}
                                        allowClear
                                    >
                                        {getReportMode.map((ele, index) => (
                                            <Option key={ele.name || index} value={ele.name}>
                                                {ele.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Col>

                                {/* Date Range */}
                                <Col xs={24} sm={12} md={6} lg={6}>
                                    <label className="form-label d-block mb-1">Date Range</label>
                                    <RangePicker
                                        className="w-100"
                                        format={dateFormat}
                                        onChange={onChangeDatePickerValue}
                                        value={dateRange}
                                        allowClear={true}
                                    />
                                </Col>

                                {/* Status */}
                                <Col xs={24} sm={12} md={5} lg={5}>
                                    <label className="form-label d-block mb-1">Status</label>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select Status"
                                        onChange={onChangeTypeStatus}
                                        value={searchStatus}
                                        allowClear
                                    >
                                        {uitilityOfflineStatusInArray.map((status) => (
                                            <Option key={status.value} value={status.value}>
                                                {status.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Col>

                                {/* Search */}
                                <Col xs={24} sm={12} md={5} lg={5}>
                                    <label className="form-label d-block mb-1">Search</label>
                                    <Input
                                        placeholder="Transaction ID, Account No, etc..."
                                        onChange={onSearchChange}
                                        value={search}
                                        allowClear
                                    />
                                </Col>

                                {/* Action Buttons */}
                                <Col xs={24} sm={24} md={3} lg={3} className="d-flex align-items-end">
                                    <Button
                                        type="primary"
                                        onClick={handleSearch}
                                        className="me-2 w-100"
                                    >
                                        Search
                                    </Button>
                                    <Button
                                        type="default"
                                        onClick={handleClear}
                                        className="w-100"
                                    >
                                        Clear
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </div>

                <hr />

                <div className="content">{renderActiveReport()}</div>
            </div>
        </div>
    );
}

export default UitilityReport2;